'use client';

import React from 'react';
import Image from 'next/image';

import { IResolvedReview } from '@/src/utils/collections/review.mapper';
import { ReviewDetailed } from '@/src/components/review/ReviewDetailed/ReviewDetailed';
import { ReviewClassic } from '@/src/components/review/ReviewClassic/ReviewClassic';

type IReviewProps = IResolvedReview;

export const Review = ({ type, data }: IReviewProps) => {
  return (
    <>
      {type === 'detailed' && (
        <div className="relative w-full">
          <Image
            src={'/static/icons/title-decoration-pink.svg'}
            alt="background-shape"
            width={450}
            height={300}
            className="decoration-visible lg:top-75 absolute left-0 top-[50px] -z-10 hidden w-[300px] rotate-[25deg] opacity-10 lg:w-[450px] xl:top-5 xl:w-[600px] 2xl:top-0 2xl:w-[700px]"
          />
          <ReviewDetailed {...data} />
        </div>
      )}
      {type === 'classic' && <ReviewClassic {...data} />}
    </>
  );
};
